import "./DeviceSettings.css";

import CloseIcon from "@mui/icons-material/Close";
import React from "react";

const uniqueDevices = (devices = []) => {
  const seen = new Set();
  return devices.filter((device) => {
    if (!device?.deviceId || seen.has(device.deviceId)) return false;
    seen.add(device.deviceId);
    return true;
  });
};

const DeviceSettings = ({
  showSettings,
  allDevices,
  setShowSettings,
  updateSettings,
  selectedDeviceIDs,
}) => {
  const videoInputs = uniqueDevices(allDevices?.videoInput);
  const audioOutputs = uniqueDevices(allDevices?.audioOutput);
  const audioInputs = uniqueDevices(allDevices?.audioInput);

  return showSettings ? (
    <div className="setting-container">
      <div className="setting-content ">
        <div className="setting-header-section">
          <h3 style={{ color: "white" }}>Device Settings</h3>
          <button
            className="close-button"
            onClick={() => setShowSettings(false)}
          >
            <CloseIcon fontSize="small" color="white" />
          </button>
        </div>
        <h4 style={{ color: "white" }}>Video</h4>
        {videoInputs.length > 0 ? (
          <select
            className="setting-select"
            name="video"
            id="video"
            onChange={(value) => updateSettings(value, "videoInput")}
            value={selectedDeviceIDs?.videoInput}
          >
            {videoInputs.map((item) => (
              <option key={item?.deviceId} value={item?.deviceId}>
                {item?.label}
              </option>
            ))}
          </select>
        ) : (
          <select
            className="setting-select"
            name="video"
            id="video"
            value="noData"
          >
            <option value="noData">No Camera Found</option>
          </select>
        )}
        <h4 style={{ color: "white" }}>Speaker</h4>
        {audioOutputs.length > 0 ? (
          <select
            className="setting-select"
            name="speaker"
            id="speaker"
            onChange={(value) => updateSettings(value, "audioOutput")}
            value={selectedDeviceIDs?.audioOutput}
          >
            {audioOutputs.map((item) => (
              <option key={item?.deviceId} value={item?.deviceId}>
                {item?.label}
              </option>
            ))}
          </select>
        ) : (
          <select
            className="setting-select"
            name="speaker"
            id="speaker"
            value="noData"
          >
            <option value="noData">No Speaker Found</option>
          </select>
        )}
        <h4 style={{ color: "white" }}>Microphone</h4>
        {audioInputs.length > 0 ? (
          <select
            className="setting-select"
            name="microphone"
            id="microphone"
            onChange={(value) => updateSettings(value, "audioInput")}
            value={selectedDeviceIDs?.audioInput}
          >
            {audioInputs.map((item) => (
              <option key={item?.deviceId} value={item?.deviceId}>
                {item?.label}
              </option>
            ))}
          </select>
        ) : (
          <select
            className="setting-select"
            name="microphone"
            id="microphone"
            value="noData"
          >
            <option value="noData">No Microphone Found</option>
          </select>
        )}
      </div>
    </div>
  ) : null;
};

export default DeviceSettings;
